<template>
  <BaseSubHeading
    class="read-more_content"
    :class="className"
    :style="{ height: styleHeight }"
    :size="size"
    :weight="weight"
  >
    <span :ref="ref">
      <slot name="text">
        <ReferencedText :html="text" />
      </slot>
    </span>
  </BaseSubHeading>

  <button
    v-if="addReadMore"
    class="link is-medium-500 read-more_button"
    type="button"
    @click="toggleReadMore"
  >
    {{ readMoreLabel }}
  </button>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

import BorderedTextarea from "@/components/Form/BorderedTextarea.vue"

import { ReferencedText } from "../Reference"

@Options({
  name: "ReadMore",
  components: {
    BorderedTextarea,
    ReferencedText
  }
})
export default class TextareaSwitch extends Vue {
  @Prop({ default: 0 }) readonly numberOfLines: number
  @Prop({ default: "" }) readonly id: string
  @Prop({ default: "" }) readonly text: string
  @Prop({ default: "" }) readonly className: string
  @Prop({ default: "medium" }) readonly size: string
  @Prop({ default: "400" }) readonly weight: string

  addReadMore = false
  readMore = false

  get ref() {
    return `blockHeight-${this.id}`
  }

  get contentHeight() {
    let getEllement = this.$refs[this.ref] as HTMLElement
    return getEllement ? Math.round(getEllement.offsetHeight) : 0
  }

  get hasNewLines(): boolean {
    return this.text?.includes("\n")
  }

  get styleHeight() {
    if (!this.addReadMore) {
      return "auto"
    }
    let lineHeight = this.styleFont.lineHeight
    return this.readMore ? "initial" : `calc(${lineHeight} * ${this.numberOfLines} * 1em)`
  }

  get styleFont() {
    switch (this.size) {
      case "medium":
        return {
          lineHeight: this.getCssVriable("--line-height-lg"),
          fontSize: this.getCssVriable("--font-size-lg")
        }
      case "large":
        return {
          lineHeight: this.getCssVriable("--line-height-lg"),
          fontSize: this.getCssVriable("--font-size-xl")
        }
      case "small":
        return {
          lineHeight: this.getCssVriable("--line-height-md"),
          fontSize: this.getCssVriable("--font-size-md")
        }
      case "extra-small":
        return {
          lineHeight: this.getCssVriable("--line-height-md"),
          fontSize: this.getCssVriable("--font-size-sm")
        }
      default:
        return {
          lineHeight: this.getCssVriable("--line-height-lg"),
          fontSize: this.getCssVriable("--font-size-lg")
        }
    }
  }

  getCssVriable(varName: string) {
    return Number(
      getComputedStyle(document.documentElement).getPropertyValue(varName).replace("px", "")
    )
  }

  mounted() {
    let lineHeight = this.styleFont.lineHeight
    let fontSize = this.styleFont.fontSize
    let wrapperHeight = this.numberOfLines * Math.round(lineHeight * fontSize)
    if (this.contentHeight > wrapperHeight) {
      this.addReadMore = true
    }
  }

  toggleReadMore() {
    this.readMore = !this.readMore
  }

  get readMoreLabel() {
    return this.readMore ? "Hide" : "Read More"
  }
}
</script>
